import {
  Col,
  Form,
  Input,
  Row,
  Space,
  Table,
  Upload,
  Modal,
  UploadFile,
} from 'antd';
import AddCategoryPage from './AddCategoryPage';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Button from 'components/Button';
import { useMutation, useQuery } from 'react-query';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { DownloadIcon, SyncIcon } from 'assets/svg';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { useEffect, useState } from 'react';
import { UploadProps } from 'antd/lib';
import * as XLSX from 'xlsx';
import ProductApi from 'apis/ProductApi';
import {
  IProduct,
  InsertProductForPortFolio,
} from 'interface/product.interface';
import PortfolioApi from 'apis/PortfolioApi';
import { STATUS } from 'constants/reponseStatus';
import handleError401 from 'utils/handleError401';
import { IPortfolio } from 'interface/portfolio.interface';
import { PRODUCT_POF_STATUS, PRODUCT_STATUS } from 'constants/productStatus';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import { ColumnsType } from 'antd/es/table';
import PopupConfirmBase from 'components/PopupConfirmBase';
import { openNotificationWithIcon } from 'utils/notification';
import { CloudDownloadOutlined } from '@ant-design/icons';

interface Iparam {
  id?: string;
}
export default function ProductListStepPage(): JSX.Element {
  const history = useHistory();
  const { id } = useParams<Iparam>();
  const queryParam = useQueryParam();
  const location = useLocation<{ pof_type_code: string }>();
  const setStep = useCategoryManagementStore((state) => state.setStep);
  const [modalSyncVisible, setModalSyncVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [excelData, setExcelData] = useState<InsertProductForPortFolio[]>([]);
  const [products, setProductData] = useState<IProduct[]>([]);
  const [total, setProductTotalData] = useState<number>(0);
  const [porfolioDetail, setPorfolioDetail] = useState<IPortfolio>();
  const [selectedFile, setSelectedFile] = useState<UploadFile>();
  const [page, setPage] = useState(parseInt(queryParam.get('page') + '') || 1);
  const [page_size, setPage_size] = useState(
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE
  );

  const pagination = { page: page, page_size: page_size };

  const columns: ColumnsType<IProduct> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 80,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã basic (new)',
      dataIndex: 'basic_product',
      width: 220,
    },
    {
      title: 'Mã sản phẩm',
      dataIndex: 'product_code',
      width: 261,
    },
    {
      title: 'Tên sản phẩm',
      dataIndex: 'product_name',
      width: 270,
    },
    {
      title: 'Ngành hàng',
      width: 120,
      dataIndex: 'prod_grp2_name',
    },
    {
      title: 'Dòng hàng SAP',
      dataIndex: 'line_sap',
      width: 160,
    },
    {
      title: 'Xman',
      dataIndex: 'line_xman_text',
      width: 160,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chungloai_text',
      width: 112,
    },
    {
      title: 'Giá vốn tồn tham khảo',
      dataIndex: 'cost_price',
      width: 185,
      align: 'right',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Giá bán',
      dataIndex: 'price',
      width: 135,
      align: 'right',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Giá vốn bình quân',
      dataIndex: 'cost_price',
      width: 185,
      align: 'right',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Loại đá',
      dataIndex: 'loai_da',
      width: 124,
    },
    {
      title: 'Nhóm đá',
      dataIndex: 'nhom_da',
      width: 124,
    },
    {
      title: 'BST',
      dataIndex: 'bst_text',
      width: 200,
    },
    {
      title: 'Bộ',
      dataIndex: 'zma_bo_text',
      width: 300,
    },
    {
      title: 'Cặp',
      dataIndex: 'zma_ts_cap_text',
      width: 300,
    },
    {
      title: 'Giới tính',
      dataIndex: 'gioitinh_text',
      width: 90,
    },
    {
      title: 'Material Type',
      dataIndex: 'material_type',
      width: 126,
    },
    {
      title: 'Tuổi vàng',
      dataIndex: 'purity_of_gold',
      width: 99,
    },
    {
      title: 'Màu sắc',
      dataIndex: 'mausac_text',
      width: 150,
    },
    {
      title: 'Size ổ hột',
      // dataIndex: 'size',
      width: 99,
      render: (product: IProduct) => {
        return <>{product.ohot_kc || ''}</>;
      },
    },
    {
      title: 'Xplant Status',
      dataIndex: 'xplant_status',
      width: 125,
    },
    {
      title: 'Phân nhóm',
      dataIndex: 'phan_nhom',
      width: 204,
    },
    {
      title: 'Trạng thái mẫu',
      dataIndex: 'brand',
      width: 135,
    },
    {
      title: 'Is_DMHHKN',
      dataIndex: 'brand',
      width: 115,
    },
    {
      title: 'PLHH',
      dataIndex: 'brand',
      width: 114,
    },
    {
      title: 'Material (Mẫu đại diện)',
      dataIndex: 'mau_dai_dien',
      width: 190,
      render: (record: any) => {
        return <>{record?.toString()}</>;
      },
    },
    {
      title: 'Mã 17',
      dataIndex: 'brand',
      width: 114,
    },
    {
      title: 'Material Group',
      dataIndex: 'material_group',
      width: 134,
    },
    {
      title: 'PL ni => Khung ni chuẩn (hàng mới)',
      dataIndex: 'brand',
      width: 270,
    },
    {
      title: 'DGTQ',
      dataIndex: 'kldg_3tc',
      width: 73,
    },
    {
      title: 'PL tình trạng theo dõi NLSX',
      dataIndex: 'brand',
      width: 219,
    },
    // {
    //   title: 'Danh mục cũ',
    //   dataIndex: 'brand',
    //   width: 121,
    // },
    // {
    //   title: 'Danh mục',
    //   dataIndex: 'brand',
    //   width: 114,
    // },
    {
      title: 'Trạng thái sản phẩm',
      width: 171,
      render: (product: IProduct) => (
        <span>
          {
            PRODUCT_POF_STATUS.find((item) => item.value === product.pof_status)
              ?.label
          }
        </span>
      ),
    },
    // {
    //   title: 'Vòng đời giỏ hàng hiện tại',
    //   width: 283,
    // },
    {
      title: 'Trạng thái bán hàng',
      width: 168,
      render: (product: IProduct) => (
        <span>
          {PRODUCT_STATUS.find((item) => item.value === product.status)?.label}
        </span>
      ),
    },
    // {
    //   title: 'Doanh thu 6 tháng gần nhất',
    //   dataIndex: 'doanhthu_6th',
    //   width: 283,
    //   align: 'right',
    // },
    // {
    //   title: 'Tồn hiện tại',
    //   children: [
    //     {
    //       title: 'Tổng SL',
    //       dataIndex: 'tongsl_ton',
    //       width: 150,
    //       align: 'right',
    //     },
    //     {
    //       title: 'Tổng giá trị',
    //       dataIndex: 'tong_giatri',
    //       width: 150,
    //       align: 'right',
    //     },
    //   ],
    // },
    {
      fixed: 'right',
      align: 'center',
      width: 0,
    },
  ];

  useQuery(['getDetail'], () => PortfolioApi.getDetail(id || ''), {
    onSuccess: (response: any) => {
      if (response.status === STATUS.SUCCESS) {
        setPorfolioDetail(response.data);
      }
    },
    onError: (error: any) => {
      if (error.response.data.status === 401) {
        handleError401();
      }
    },
  });

  const { mutate: getProducts, isLoading: isProductLoading } = useMutation(
    () => PortfolioApi.getProducts(porfolioDetail?.pof_code || '', pagination),
    {
      onSuccess: (response: any) => {
        if (response.status === STATUS.SUCCESS) {
          setProductData(response.data);
          setProductTotalData(response.total);
        }
      },
      onError: (error: any) => {
        console.log(error);
      },
    }
  );

  const { mutate: getProductsGCP, isLoading: isProductLoadingGCP } =
    useMutation(
      (pof_code: string) =>
        PortfolioApi.getProducts(pof_code || '', pagination),
      {
        onSuccess: (response: any) => {
          if (response.status === STATUS.SUCCESS) {
            setProductData(response.data);
            setProductTotalData(response.total);
          }
        },
        onError: (error: any) => {
          console.log(error);
        },
      }
    );

  const { mutate: getGCP, isLoading: getGCPLoading } = useMutation(
    () =>
      ProductApi.postGCP({
        pof_code: porfolioDetail?.pof_code,
        pof_type_code: porfolioDetail?.pof_type_code,
      }),
    {
      onSuccess: (response: any) => {
        if (response.success === true) {
          getProductsGCP(response.data?.pof_code);
        } else {
          openNotificationWithIcon('error', response.message);
        }
      },
      onError: (error: any) => {
        console.log(error);
      },
    }
  );

  const openModal = (content: string) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent('');
  };

  const successModal = () => {
    const allAreTrue = excelData.every((item) => item.status !== 0);
    if (allAreTrue) {
      setModalSyncVisible(false);

      getProducts();
    } else {
      openModal(
        'Đang đồng bộ danh sách sản phẩm từ khuôn, vui lòng chờ trong giây lát'
      );
    }
  };

  useEffect(() => {
    document.title = 'PNJ - PMS';
    setStep(1);
    if (porfolioDetail) {
      getProducts();
    }
  }, [page, page_size, porfolioDetail]);

  const onNextStep = (values: any) => {
    if (products.length != 0) {
      closeModal();
      history.push(`/add-category/approve-step/${id}`, {
        pof_type_code:
          location.state?.pof_type_code ?? porfolioDetail?.pof_type_code,
        pof_code: porfolioDetail?.pof_code,
      });
    } else {
      openModal('Chưa có sản phẩm nào được đồng bộ, vui lòng đồng bộ sản phẩm');
    }
  };

  function generateExcel() {
    const data = [
      ['Mẫu import mã basic (new)'],
      ['Mã basic (new)'],
      ['GM0000Y000431.000'],
      ['GM0000WZ00023.000'],
      ['GB0000Y000983.000'],
      ['GB0000Y000987.000'],
      ['GE0000Y000001.000'],
    ];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `mau_khuon.xlsx`);
  }

  function handleFileChange(info: UploadProps) {
    try {
      if (info.fileList) {
        const files = info.fileList.map((file: any) => {
          return file.originFileObj;
        });
        if (files.length != 0) {
          const file = info.fileList[0];
          setSelectedFile(file);
          const reader = new FileReader();

          reader.onload = (e) => {
            if (e.target) {
              const data = e.target.result;
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];
              let excelData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
                header: 1,
                range: 0,
              });
              excelData = excelData.slice(1);
              if (
                excelData.length == 0 ||
                excelData[0][0] != 'Mã basic (new)'
              ) {
                openModal('File không đúng mẫu, vui lòng tải mẫu');
                return;
              }
              excelData = excelData.slice(1);
              const jsonData: InsertProductForPortFolio[] = [];
              excelData.forEach((row, index) => {
                if (row[0]) {
                  const param = {
                    pof_type_code: porfolioDetail?.pof_type_code || '',
                    pof_code: porfolioDetail?.pof_code || '',
                    basic_product: row[0] || '',
                    count_product: 0,
                    status: 1,
                    message: '',
                  };
                  jsonData.push(param);
                }
              });
              setExcelData(jsonData);
              setModalSyncVisible(true);

              setTimeout(async () => {
                jsonData.forEach((item) => {
                  insertProductForPortfolio(item);
                });
              }, 1000);
            }
          };
          const blob = file.originFileObj as Blob;
          reader.readAsArrayBuffer(blob);
        }
      }
    } catch (err) {
      openNotificationWithIcon('error', 'File không đúng định dạng mẫu');
    }
  }

  const { mutate: insertProductForPortfolio, isLoading } = useMutation(
    ProductApi.insertProductForPortfolio,
    {
      onSuccess: (data, variables) => {
        if (data.success) {
          setExcelData((prevExcelData) =>
            prevExcelData.map((item) =>
              item.basic_product === data.data.basic_product
                ? {
                    ...item,
                    count_product: data.data.count_product,
                    status: 2,
                    message: '',
                  }
                : item
            )
          );
        } else {
          const { basic_product } = variables;

          setExcelData((prevExcelData) =>
            prevExcelData.map((item) =>
              item.basic_product === basic_product
                ? { ...item, status: 3, message: data?.message }
                : item
            )
          );
        }
      },
      onError: (error: any, variables) => {
        const { basic_product } = variables;
        setExcelData((prevExcelData) =>
          prevExcelData.map((item) =>
            item.basic_product === basic_product
              ? { ...item, status: 3, message: error?.response?.data?.message }
              : item
          )
        );
      },
    }
  );

  return (
    <AddCategoryPage>
      <Form
        layout="vertical"
        className="items-center"
        onFinish={onNextStep}
        autoComplete="off"
      >
        <Content>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            align="middle"
          >
            <Col span={12}>
              <div className="text-xl font-bold">2. Danh sách sản phẩm</div>
            </Col>
            <Col span={12}>
              <Row justify="end" align="middle">
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    customClass="fix-border-radius"
                    onClick={generateExcel}
                  >
                    Tải mẫu tại đây
                    <DownloadIcon />
                  </Button>
                  {location.state?.pof_type_code == 'suggest' && (
                    <Button
                      bgColor={'bg-white'}
                      color={'text-primary-50'}
                      border={'border-primary-50'}
                      customClass="fix-border-radius"
                      onClick={() => {
                        getGCP();
                      }}
                    >
                      DMKN GCP
                      <CloudDownloadOutlined style={{ marginTop: '3px' }} />
                    </Button>
                  )}
                </Space>
              </Row>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={24}>
              <p className="ml-4">
                Danh sách sản phẩm <span className="text-red-500">*</span>
              </p>
              <Form.Item name="plantCode">
                <Space.Compact className="w-full mt-2">
                  <Input
                    style={{ width: 'calc(100% - 130px)', marginRight: '8px' }}
                    placeholder="Tải file định dạng .xls, .csv"
                    value={selectedFile?.name}
                  />
                  <Upload
                    accept=".xlsx,.xls,.csv"
                    onChange={handleFileChange}
                    beforeUpload={() => false}
                    fileList={[]}
                    showUploadList={false}
                  >
                    <Button
                      bgColor={'bg-white'}
                      color={'text-primary-50'}
                      border={'border-primary-50'}
                      customClass="fix-border-radius"
                    >
                      Browser
                    </Button>
                  </Upload>
                </Space.Compact>
              </Form.Item>
            </Col>
          </Row>
          <Table
            rowKey={(record, index) => index + ''}
            className="customTable"
            size="small"
            columns={columns}
            dataSource={products}
            scroll={{ x: 970 }}
            loading={isLoading || getGCPLoading || isProductLoadingGCP}
            pagination={{
              className: 'flex items-center',
              current: page,
              pageSize: page_size,
              total: total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],

              onChange: (page: number, pageSize: number) => {
                setPage(page);
                setPage_size(pageSize);

                history.push(`/add-category/product-list-step/${id}`, {
                  pof_type_code: porfolioDetail?.pof_type_code,
                  page: page,
                  page_size: pageSize,
                });
              },
            }}
          />
        </Content>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
          style={{ marginTop: '20px', marginRight: '2px' }}
        >
          <Form.Item>
            <Button type="submit">Tiếp theo</Button>
          </Form.Item>
        </Row>
      </Form>
      <Modal
        title="Danh sách khuôn"
        visible={modalSyncVisible}
        onCancel={closeModal}
        footer={null}
        width={'80%'}
      >
        <Table
          rowKey={(record) => record.basic_product}
          className="customTable"
          size="small"
          // pagination={false}
          pagination={{
            className: 'flex items-center',
          }}
          scroll={{ x: 958 }}
          columns={[
            {
              title: 'Mã basic (new)',
              dataIndex: 'basic_product',
              key: 'basic_product',
            },
            {
              title: 'Số lượng sp',
              dataIndex: 'count',
              key: 'count',
            },
            {
              title: 'Trạng thái đồng bộ',
              // dataIndex: 'status',
              key: 'status',
              render: (record: any) => {
                if (record.status === 'Lỗi') {
                  return <p style={{ color: '#DC362E' }}>{record.status}</p>;
                } else {
                  return <p>{record.status}</p>;
                }
              },
            },
            {
              title: 'Thông tin lỗi',
              dataIndex: 'mesage',
              key: 'mesage',
            },
            {
              title: 'Đồng bộ',
              fixed: 'right',
              width: 100,
              align: 'center',
              render: (record) => (
                <button
                  onClick={() => {
                    const param = {
                      basic_product: record.basic_product,
                      product_code: record.product_code,
                      count_product: 0,
                      pof_code: porfolioDetail?.pof_code || '',
                      pof_type_code: porfolioDetail?.pof_type_code || '',
                      status: 1,
                      message: '',
                    };
                    excelData.map((item) => {
                      if (item.basic_product === record.basic_product) {
                        item.status = param.status;
                      }
                      return item;
                    });

                    setExcelData(excelData);

                    insertProductForPortfolio(param);
                  }}
                >
                  <SyncIcon />
                </button>
              ),
            },
          ]}
          dataSource={excelData.map((row, index) => {
            return {
              basic_product: row.basic_product,
              status:
                row.status == 0
                  ? 'Chưa đồng bộ'
                  : row.status == 1
                  ? 'Đang đồng bộ'
                  : row.status == 2
                  ? 'Hoàn tất'
                  : 'Lỗi',
              mesage: row.message,
              count: row.count_product,
            };
          })}
        />
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
          <Col
            className="flex justify-end"
            span={8}
            style={{ marginTop: '20px' }}
          >
            <Form.Item className="mr-2">
              <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
                customClass="fix-border-radius"
                onClick={() => {
                  getProducts();
                  setModalSyncVisible(false);
                }}
              >
                Hủy
              </Button>
            </Form.Item>
            <Form.Item>
              <Button key="ok" onClick={successModal}>
                Xong
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Modal>
      <PopupConfirmBase
        isVisible={isModalOpen}
        title={'Thông báo'}
        description={modalContent}
        onlyOK={true}
        onOk={() => {
          closeModal();
        }}
      ></PopupConfirmBase>
    </AddCategoryPage>
  );
}
